import { buildImgSrc } from '@/helpers/image-url'
import { LazyImage } from '@/scopes/common/components/Image'
import { useAccommodationContext } from '@/scopes/prices/components/AccommodationContext'
import { PriceBreakdown } from '@/scopes/prices/components/PriceBasket/PriceBreakdown'
import { TripSummary } from '@/scopes/prices/components/PriceBasket/TripSummary'
import { getTransportSelector, transportResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { mqMin, space } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import { styled } from 'styled-components'

const Column = styled.div`
  flex: 1 0 0;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    flex-direction: row;
  }

  ${Column}:first-child {
    @media ${mqMin('primitives_breakpoint_m_min')} {
      margin-right: ${space('primitives_space_24')};
    }

    @media ${mqMin('primitives_breakpoint_l_min')} {
      margin-right: ${space('primitives_space_32')};
    }

    & > :first-child {
      display: none;
      height:150px;
      border-radius: ${space('primitives_space_8')};

      @media ${mqMin('primitives_breakpoint_m_min')} {
        display: block;
      }

      @media ${mqMin('primitives_breakpoint_l_min')} {
        height: 320px;
      }
    }
  }
`

export function PriceBasket() {
  const { image, name } = useAccommodationContext()
  const { tripSummary } = usePricesSelector(transportResponseSelector)
  const { loading } = usePricesSelector(getTransportSelector)

  if (loading || isEmpty(tripSummary))
    return null

  return (
    <Wrapper>
      <Column>
        <LazyImage
          src={buildImgSrc(image, 640) ?? ''}
          alt={name}
        />
        <TripSummary />
      </Column>
      <Column>
        <PriceBreakdown />
      </Column>
    </Wrapper>
  )
}
